module.exports = __webpack_public_path__ + "svg/flags/British Indian Ocean Territory.svg";